module.exports = __webpack_public_path__ + "img/2-1-ajuntament-de-palma.6b6535cd.jpg";